import * as React from "react";
const SvgFiBrandsDigg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M6.68 5.677v1.374h1.974s.252.007.252-.278L8.907 5.4H6.932a.25.25 0 0 0-.252.278m.001 2.852v7.43h1.973s.252.005.252-.279l.001-7.429H6.933s-.252-.006-.252.278m-2.9-2.852v2.575H.252S0 8.245 0 8.53v7.428h5.755s.252.007.252-.278L6.008 5.4H4.033a.25.25 0 0 0-.252.277m.001 8.348c0 .285-.253.28-.253.28H2.182v-4.123c0-.285.253-.279.253-.279h1.348zm5.89-5.496v7.428h3.781v.992H9.924s-.252-.007-.252.278v1.374h5.755s.252.007.252-.278l.001-10.068-5.756-.004s-.252-.006-.252.278m2.182 1.652c0-.285.253-.279.253-.279h1.348v4.122c0 .285-.253.28-.253.28h-1.348zm4.843-1.93s-.252-.007-.252.278v7.428h3.781v.992h-3.528s-.252-.007-.252.278v1.374H22.2s.252.007.252-.278l.001-10.068zm3.53 5.774c0 .285-.253.28-.253.28h-1.348v-4.123c0-.285.253-.279.253-.279h1.348zM23.112 8.451h-.106v-.129h.352v.13h-.106v.565h-.139v-.566M23.46 8.322h.177l.036.265q.016.11.022.224l.024-.224.045-.265h.176l.06.695h-.14l-.015-.322q-.006-.096-.008-.242l-.09.564h-.1l-.086-.568c0 .088-.007.17-.012.247l-.02.321h-.138z"
    />
  </svg>
);
export default SvgFiBrandsDigg;
